module.exports = __webpack_public_path__ + "static/media/nicolas_dominguez.948ce83c.jpg";